import { DarkModeSwitch } from "react-toggle-dark-mode";
import React, { useState, useEffect } from "react";
import Formulario from "./Formulario";
import CostCalculadora from "./CostCalculadora";
import TarifaPorCosto from "./TarifaPorCosto";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Offcanvas,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import styled, { keyframes } from "styled-components";
import logoCata from "./assets/bus-buscatupasaje.png";
import CrearUsuario from "./CrearUsuario";
import ModificarContraseña from "./ModificarContraseña";
import IniciarSesion from "./IniciarSesion";
import CerrarSesion from "./CerrarSesion";
import UserProfile from "./UserData";
import { GoogleMapsProvider } from "./GoogleMapsContext";
import DataEntryForm from "./DataEntryForm";
import { DataProvider } from "./DataContext";
import SkeletonLoader from "./SkeletonLoader";
import FirestoreTablePresupuesto from "./FirestoreTablePresupuesto";
import FirestoreTableContrato from "./FirestoreTableContrato";
import FirestoreTableVoucher from "./FirestoreTableVoucher";
import ContratoApp from "./ContratoApp";
import VoucherApp from "./VoucherApp";
import { AuthProvider } from "./AuthContext";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // agregar Link si se van a visualizar las opciones del nav
import SolicitudEventual from "./SolicitudEventual";
import SolicitudGimnasia from "./SolicitudGimnasia";
import logoCataInt from "./assets/logoCataInt.png";
import SolicitudLista from "./SolicitudListado";
import ServiciosReceptivos from "./ServiciosReceptivos";
import RegistroGimnasia from "./RegistroGimnasia";
import RegistroGodoyCruz from "./RegistroGodoyCruz";
import ConfirmarPresupuesto from "./ConfirmarPresupuestos";
import SolicitudMIM from "./SolicitudMIM";
import LanguageSelector from "./LanguageSelector";
import "./i18n";
import { useTranslation } from "react-i18next";
import SatisfactionSurvey from "./SatisfactionSurvey";
import BusDiagrama from "./BusDiagrama";
import ConfirmacionContrato from "./ConfirmacionContrato";
import LiquidacionContratos from "./LiquidacionContratos";

const Contenedor = styled.div`
  width: 100%;
  margin: 1rem 0rem 4.5rem 0rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  p {
    margin: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    justify-content: center;
  }
`;
const StyledNavbar = styled(Navbar)`
  background-color: #c20000 !important;
`;
const ContenedorDiv = styled.div`
  margin-bottom: 4.5rem;
`;
const Alert = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 2px;
  color: white;
  padding: 30px;
  z-index: 1;
`;
const CloseButton = styled.button`
  position: absolute;
  top: 1px;
  right: 2px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
`;
const Banner = styled.div`
  position: sticky;
  top: 0;
  text-align: left;
  margin-top: 65px;
  display: flex;
  gap: 10px;
  margin-left: 20px;
  & p {
    font-size: small;
    margin: 0px;
  }
`;
const LogoEmpresa = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 20px;
  background-image: url(${logoCata});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-size: 25px;
  position: absolute;
  right: 0;
`;
const ContenedorFormulario = styled.div`
  width: 100%;
  text-align: center;
`;
const EstiloButton = styled.button`
  margin: 5px auto 5px auto;
  background-color: #fff; /* Fondo blanco sobrio */
  color: #c20000; /* Rojo oscuro para el texto */
  border: 2px solid #c20000; /* Borde rojo oscuro */
  padding: 5px 10px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px; /* Bordes ligeramente redondeados */
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #c20000; /* Cambia a rojo en hover */
    color: #fff; /* Texto blanco en hover */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2); /* Sombra ligera en hover */
  }
  &:active {
    background-color: #a80000; /* Rojo más oscuro en clic */
    box-shadow: none; /* Sin sombra en clic */
  }
  &:disabled {
    background-color: #f0f0f0; /* Fondo gris claro */
    color: #a8a8a8; /* Texto gris claro */
    border: 2px solid #d0d0d0; /* Borde gris */
    cursor: not-allowed; /* Cursor desactivado */
  }
`;
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const SpinerContenedor = styled.div`
  margin-top: 20vh;
  width: 50px;
  height: 50px;
  position: relative;
`;
const Spiner = styled.div`
  border: 5px solid rgba(255, 255, 255, 0.486);
  border-top: 5px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 2s linear infinite;
  position: absolute;
  top: 5px;
  left: 5px;
`;
const SpinerCargando = styled.div`
  margin-top: 6px;
  margin-bottom: 150vh;
  font-weight: bold;
`;
const Login = styled.div`
  margin-top: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  & h5 {
    margin-bottom: 2.5rem;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    margin-bottom: 20vh;
  }
`;
const LoginLinea = styled.div`
  width: 25vw;
  height: 2px;
  background-color: #c20000;
`;
const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #c20000;
  color: white;
  text-align: center;
  padding: 10px;
  z-index: 1;
`;

const App = () => {
  const { t } = useTranslation();

  const [hover, setHover] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(true);
  const [mostrarDivForm, setMostrarDivForm] = useState(true);
  const [mostrarDivMaps, setMostrarDivMaps] = useState(true);
  const [mostrarContrato, setMostarContrato] = useState(false);
  const [mostrarCosto, setMostrarCosto] = useState(false);
  const [mostrarTarifaPorCosto, setMostrarTarifaPorCosto] = useState(false);
  const [mostrarPresupuesto, setMostrarPresupuesto] = useState(false);
  const [mostrarConfirmarPresupuesto, setMostrarConfirmarPresupuesto] =
    useState(false);
  const [mostrarRegistroGodoyCruz, setMostrarRegistroGodoyCruz] =
    useState(false);
  const [mostrarRegistroGimnasia, setMostrarRegistroGimnasia] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [mostrarModificarContraseña, setMostrarModificarContraseña] =
    useState(false);
  const [mostrarDataEntryForm, setMostrarDataEntryForm] = useState(false);
  const [mostrarVoucherForm, setMostrarVoucherForm] = useState(false);
  const [mostrarDatabase, setMostrarDatabase] = useState(false);
  const [mostrarSolicitudes, setMostrarSolicitudes] = useState(false);
  const [mostrarReceptivos, setMostrarReceptivos] = useState(false);
  const [mostrarBusDiagrama, setMostrarBusDiagrama] = useState(false);
  const [mostrarVentas, setMostrarVentas] = useState(false);
  const [loading, setLoading] = useState(true);

  const [perfil, setPerfil] = useState(null);
  const [usuario, setUsuario] = useState(null);

  const handlePerfilChange = (perfil) => {
    setPerfil(perfil);
  };
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  // Esta función se pasará como prop al componente IniciarSesion
  const actualizarUsuario = (nuevoUsuario) => {
    setUsuario(nuevoUsuario);
  };

  //////////////////////////////////////////

  //Al iniciar la aplicación, lee el valor del modo oscuro almacenado en localStorage
  const storedDarkMode = JSON.parse(localStorage.getItem("isDarkMode"));
  const [isDarkMode, setDarkMode] = useState(storedDarkMode || false);

  const toggleDarkMode = (checked) => {
    setDarkMode(checked);
  };

  useEffect(() => {
    // guarda el estado del modo oscuro
    localStorage.setItem("isDarkMode", JSON.stringify(isDarkMode));

    // Definimos los estilos que queremos para el modo claro y oscuro
    const lightModeStyles = {
      background: "white",
      color: "#404040",
    };

    const darkModeStyles = {
      background: "#0c0d0d",
      color: "white",
    };

    // Dependiendo del valor de isDarkMode, aplicamos los estilos adecuados
    if (isDarkMode) {
      Object.keys(darkModeStyles).forEach((style) => {
        document.body.style[style] = darkModeStyles[style];
      });
    } else {
      Object.keys(lightModeStyles).forEach((style) => {
        document.body.style[style] = lightModeStyles[style];
      });
    }
  }, [isDarkMode]);

  /////////////////////////////////////////////////
  const resetStates = () => {
    setMostrarFormulario(false);
    setMostrarDivForm(false);
    setMostrarDivMaps(false);
    setMostarContrato(false);
    setMostrarCosto(false);
    setMostrarTarifaPorCosto(false);
    setMostrarPresupuesto(false);
    setMostrarConfirmarPresupuesto(false);
    setMostrarRegistroGodoyCruz(false);
    setMostrarRegistroGimnasia(false);
    setMostrarUsuario(false);
    setMostrarModificarContraseña(false);
    setMostrarDataEntryForm(false);
    setMostrarVoucherForm(false);
    setMostrarDatabase(false);
    setMostrarSolicitudes(false);
    setMostrarReceptivos(false);
    setMostrarBusDiagrama(false);
    setMostrarVentas(false);
  };

  const handleVentas = () => {
    resetStates();
    setMostrarVentas(true);
  };
  const handleMostrarReceptivos = () => {
    resetStates();
    setMostrarReceptivos(true);
  };
  const handleMostrarSolicitudes = () => {
    resetStates();
    setMostrarSolicitudes(true);
  };
  const handleMostrarDatabase = () => {
    resetStates();
    setMostrarDatabase(true);
  };

  const handleMostrarVoucherForm = () => {
    resetStates();
    setMostrarVoucherForm(true);
  };

  const handleMostrarDataEntryForm = () => {
    resetStates();
    setMostrarDataEntryForm(true);
  };

  const handleMostrarModificarContraseña = () => {
    resetStates();
    setMostrarModificarContraseña(true);
  };

  const handleMostrarUsuarios = () => {
    resetStates();
    setMostrarUsuario(true);
  };

  const handleMostrarTarifaPorCosto = () => {
    resetStates();
    setMostrarTarifaPorCosto(true);
  };

  const handleMostrarCosto = () => {
    resetStates();
    setMostrarCosto(true);
  };

  const handleMostrarContrato = () => {
    resetStates();
    setMostarContrato(true);
  };

  const handlePresupuesto = () => {
    resetStates();
    setMostrarFormulario(true);
    setMostrarPresupuesto(true);
  };

  const handleConfirmarPresupuesto = () => {
    resetStates();
    setMostrarConfirmarPresupuesto(true);
  };

  const handleMostrarGodoyCruz = () => {
    resetStates();
    setMostrarRegistroGodoyCruz(true);
  };

  const handleMostrarGimnasia = () => {
    resetStates();
    setMostrarRegistroGimnasia(true);
  };

  const handleMostrarFormulario = () => {
    resetStates();
    setMostrarFormulario(true);
    setMostrarDivForm(true);
    setMostrarDivMaps(true);
  };

  const handleMostrarBusDiagrama = () => {
    resetStates();
    setMostrarBusDiagrama(true);
  };

  function abrirEnlaceExterno(url) {
    const ventanaNueva = window.open(
      url,
      "_blank",
      "fullscreen=yes,scrollbars=no"
    );
    if (ventanaNueva) {
      ventanaNueva.focus();
    } else {
      setShowAlert(true);
    }
  }

  // Simula una carga de perfil asincrónica
  useEffect(() => {
    // Si no hay usuario, establece loading en true
    if (!usuario) {
      setLoading(true);
    } else {
      // Si hay usuario, espera 2 segundos antes de establecer loading en false
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [usuario]);

  useEffect(() => {
    if (perfil === "administrador" || perfil === "comercial") {
      resetStates();
      setMostrarSolicitudes(true);
    } else {
      resetStates();
      setMostrarFormulario(true);
      setMostrarDivForm(true);
      setMostrarDivMaps(true);
    }
  }, [perfil]);

  return (
    <DataProvider>
      <AuthProvider>
        {showAlert && (
          <Alert>
            <CloseButton onClick={closeAlert}>&times;</CloseButton>
            No se pudo abrir la ventana. Asegúrate de desactivar los
            bloqueadores de ventanas emergentes.
          </Alert>
        )}
        <div>
          {usuario ? (
            <div>
              {["md"].map((expand) => (
                <StyledNavbar
                  fixed="top"
                  key={expand}
                  expand={expand}
                  className="bg-body-tertiary mb-3"
                  bg="dark"
                  data-bs-theme="dark"
                >
                  <Container fluid>
                    <Navbar.Brand href="#" onClick={handleMostrarFormulario}>
                      CataApp
                    </Navbar.Brand>
                    <Navbar.Toggle
                      aria-controls={`offcanvasNavbar-expand-${expand}`}
                      style={{
                        marginRight: "60px",
                        boxShadow: "none",
                        border: "none",
                      }}
                    />
                    <Navbar.Offcanvas
                      id={`offcanvasNavbar-expand-${expand}`}
                      aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                      placement="end"
                      className="w-50"
                      style={{
                        background: "#0a0a0ac9",
                        color: "white",
                      }}
                    >
                      <Offcanvas.Header
                        closeButton
                        className="bg-light text-black"
                      >
                        <Offcanvas.Title
                          id={`offcanvasNavbarLabel-expand-${expand}`}
                        >
                          Menú
                        </Offcanvas.Title>
                      </Offcanvas.Header>
                      <Offcanvas.Body>
                        <div className="mr-auto">
                          <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link onClick={handleMostrarFormulario}>
                              {perfil === "terminal"
                                ? "Proyección"
                                : "Cotizador"}
                            </Nav.Link>
                            {perfil === "terminal" ? null : (
                              <NavDropdown
                                title="Presupuesto"
                                id={`offcanvasNavbarDropdown-expand-${expand}`}
                                data-bs-theme="light"
                              >
                                <NavDropdown.Item onClick={handlePresupuesto}>
                                  Generar Presupuesto
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                  onClick={handleConfirmarPresupuesto}
                                >
                                  Confirmar Presupuesto
                                </NavDropdown.Item>
                              </NavDropdown>
                            )}
                            {perfil === "administrador" ||
                            perfil === "turismo" ? (
                              <>
                                <NavDropdown
                                  title="Tarifario"
                                  id={`offcanvasNavbarDropdown-expand-${expand}`}
                                  data-bs-theme="light"
                                >
                                  <NavDropdown.Item
                                    onClick={handleMostrarReceptivos}
                                  >
                                    Serv. Receptivos
                                  </NavDropdown.Item>
                                </NavDropdown>
                              </>
                            ) : null}
                            <NavDropdown
                              title="Otras opciones"
                              id={`offcanvasNavbarDropdown-expand-${expand}`}
                              data-bs-theme="light"
                            >
                              {perfil === "terminal" ? null : (
                                <>
                                  <NavDropdown.Item
                                    onClick={handleMostrarContrato}
                                  >
                                    Generar Contrato
                                  </NavDropdown.Item>

                                  <NavDropdown.Item
                                    onClick={handleMostrarTarifaPorCosto}
                                  >
                                    Tarifa por Costo
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarVoucherForm}
                                  >
                                    Generar Voucher
                                  </NavDropdown.Item>
                                </>
                              )}
                              {perfil === "terminal" ||
                              perfil === "turismo" ? null : (
                                <>
                                  <NavDropdown.Item
                                    onClick={handleMostrarBusDiagrama}
                                  >
                                    Diagrama Bus
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarDatabase}
                                  >
                                    Archivos
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarSolicitudes}
                                  >
                                    Solicitudes
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarGodoyCruz}
                                  >
                                    Servicios Godoy Cruz
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarGimnasia}
                                  >
                                    Servicios Gimnasia
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleVentas}
                                  >
                                    Ventas
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={() =>
                                      abrirEnlaceExterno(
                                        "https://trello.com/b/ziQYuNtk/servicios-especiales"
                                      )
                                    }
                                    target="_blank"
                                  >
                                    Trello
                                  </NavDropdown.Item>
                                </>
                              )}
                              <NavDropdown.Item onClick={handleMostrarCosto}>
                                Calcular Costos
                              </NavDropdown.Item>
                              {perfil === "administrador" ? (
                                <>
                                  <NavDropdown.Item
                                    onClick={handleMostrarUsuarios}
                                  >
                                    Usuarios
                                  </NavDropdown.Item>
                                  <NavDropdown.Item
                                    onClick={handleMostrarDataEntryForm}
                                  >
                                    Data Entry
                                  </NavDropdown.Item>
                                </>
                              ) : null}
                              <NavDropdown.Item
                                onClick={handleMostrarModificarContraseña}
                              >
                                Contraseña
                              </NavDropdown.Item>
                            </NavDropdown>
                          </Nav>
                        </div>
                      </Offcanvas.Body>
                    </Navbar.Offcanvas>
                  </Container>
                  <LogoEmpresa></LogoEmpresa>
                </StyledNavbar>
              ))}
              {loading ? (
                <>
                  <Banner>
                    <DarkModeSwitch
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                      checked={isDarkMode}
                      onChange={toggleDarkMode}
                    />
                    <CerrarSesion
                      isDarkMode={isDarkMode}
                      setUsuario={setUsuario}
                    />
                    <p>Bienvenido </p>
                    <UserProfile onPerfilChange={handlePerfilChange} />
                  </Banner>
                  <SkeletonLoader />
                </>
              ) : (
                <div>
                  <Banner>
                    <DarkModeSwitch
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                      checked={isDarkMode}
                      onChange={toggleDarkMode}
                      color={hover ? "#a7a7a7" : isDarkMode ? "white" : "black"}
                    />
                    <CerrarSesion
                      isDarkMode={isDarkMode}
                      setUsuario={setUsuario}
                    />
                    <p>Hola </p>
                    <UserProfile onPerfilChange={handlePerfilChange} />
                  </Banner>
                  {mostrarTarifaPorCosto ? (
                    <TarifaPorCosto />
                  ) : (
                    <>
                      {mostrarCosto ? (
                        <CostCalculadora />
                      ) : (
                        <>
                          {mostrarFormulario ? (
                            <GoogleMapsProvider>
                              <ContenedorFormulario>
                                <Formulario
                                  mostrarDivForm={mostrarDivForm}
                                  mostrarDivMaps={mostrarDivMaps}
                                  mostrarPresupuesto={mostrarPresupuesto}
                                  isDarkMode={isDarkMode}
                                  perfil={perfil}
                                />
                              </ContenedorFormulario>
                            </GoogleMapsProvider>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                  {mostrarConfirmarPresupuesto && <ConfirmarPresupuesto />}
                  {mostrarContrato && <ContratoApp />}
                  {mostrarRegistroGimnasia && (
                    <ContenedorDiv>
                      <RegistroGimnasia />
                    </ContenedorDiv>
                  )}
                  {mostrarRegistroGodoyCruz && (
                    <ContenedorDiv>
                      <RegistroGodoyCruz />
                    </ContenedorDiv>
                  )}
                  {mostrarUsuario && (
                    <CrearUsuario setMostrarUsuario={setMostrarUsuario} />
                  )}
                  {mostrarModificarContraseña && <ModificarContraseña />}
                  {mostrarDataEntryForm && <DataEntryForm />}
                  {mostrarVoucherForm && <VoucherApp />}
                  {mostrarDatabase && (
                    <ContenedorDiv>
                      <FirestoreTablePresupuesto />
                      <FirestoreTableContrato />
                      <FirestoreTableVoucher />
                    </ContenedorDiv>
                  )}
                  {mostrarSolicitudes && <SolicitudLista />}
                  {mostrarReceptivos && <ServiciosReceptivos perfil={perfil} />}
                  {mostrarBusDiagrama && <BusDiagrama />}
                  {mostrarVentas && <LiquidacionContratos />}
                </div>
              )}
            </div>
          ) : (
            <Router>
              <div>
                {["md"].map((expand) => (
                  <StyledNavbar
                    fixed="top"
                    key={expand}
                    expand={expand}
                    className="bg-body-tertiary mb-3"
                    bg="dark"
                    data-bs-theme="dark"
                  >
                    <Container fluid>
                      <Navbar.Brand>
                        <img
                          src={logoCataInt}
                          width="110"
                          className="d-inline-block align-top"
                          alt="Logo de CataApp"
                        />
                      </Navbar.Brand>
                      <Navbar.Toggle
                        aria-controls={`offcanvasNavbar-expand-${expand}`}
                        style={{
                          marginRight: "60px",
                          boxShadow: "none",
                          border: "none",
                        }}
                      />
                      <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                        className="w-50"
                        style={{
                          background: "#0a0a0ac9",
                          color: "white",
                        }}
                      >
                        <Offcanvas.Header
                          closeButton
                          className="bg-light text-black"
                        >
                          <Offcanvas.Title
                            id={`offcanvasNavbarLabel-expand-${expand}`}
                          >
                            Menú
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <div className="mr-auto">
                            <Nav className="justify-content-end flex-grow-1 pe-3">
                              <Nav className="ml-auto">
                                <LanguageSelector /> {/* Selector de idioma */}
                              </Nav>

                              {/*<Nav.Link as={Link} to="/solicitud">
                                Solicitud
                      </Nav.Link>*/}
                              {/*<Nav.Link as={Link} to="/receptivos">
                                Serv. Receptivos
                      </Nav.Link>
                              <NavDropdown
                                title="Otras Opciones"
                                id={`offcanvasNavbarDropdown-expand-${expand}`}
                                data-bs-theme="light"
                              >
                                <NavDropdown.Item as={Link} to="/">
                                  Login
                                </NavDropdown.Item>
                              </NavDropdown>*/}
                            </Nav>
                          </div>
                        </Offcanvas.Body>
                      </Navbar.Offcanvas>
                    </Container>
                    <LogoEmpresa></LogoEmpresa>
                  </StyledNavbar>
                ))}
                <Banner>
                  <DarkModeSwitch
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    checked={isDarkMode}
                    onChange={toggleDarkMode}
                  />
                  <h6>{t("form.fields.welcome")}</h6>
                </Banner>
                <Contenedor>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <Login className={isDarkMode ? "classInput" : ""}>
                          <h4>Departamento de Costos</h4>
                          <h4>CATA Internacional</h4>
                          <LoginLinea></LoginLinea>
                          <h5>Acceso protegido</h5>
                          <IniciarSesion onUserChange={actualizarUsuario} />
                        </Login>
                      }
                    />
                    <Route path="/solicitud" element={<SolicitudEventual />} />
                    <Route
                      path="/solicitud-gimnasia"
                      element={<SolicitudGimnasia />}
                    />
                    <Route
                      path="/receptivos"
                      element={<ServiciosReceptivos perfil={perfil} />}
                    />
                    <Route
                      path="/solicitudMIM"
                      element={<SolicitudMIM perfil={perfil} />}
                    />
                    <Route 
                      path="/encuesta"
                      element={<SatisfactionSurvey />} 
                    />
                    <Route 
                      path="/confirmacion-contrato"
                      element={<ConfirmacionContrato />} 
                    />
                  </Routes>
                </Contenedor>
              </div>
            </Router>
          )}

          <Footer>&copy;v2.5 der2023</Footer>
        </div>
      </AuthProvider>
    </DataProvider>
  );
};

export default App;
export {
  SpinerContenedor,
  Spiner,
  SpinerCargando,
  EstiloButton,
  LogoEmpresa,
  Alert,
  CloseButton,
};
